<template>
  <div>
    <v-card elevation="0" height="70px" class="main-card-detail">
      <div class="card-content-wrapper">
        <v-icon color="darkColor" class="mr-3">{{ icon }}</v-icon>
        <span class="title-text">{{ title }}</span>
        <div class="right-content-wrapper" dir="ltr" style="direction: ltr">
          <div class="right-contentItems">
            <v-btn v-if="isPhoneNumber(text)" small text class="phone-button" @click="callToCode(text)">
              {{ text }}
            </v-btn>
            <span v-else class="text-content" :style="{ cursor: clickable ? 'pointer' : 'default' }"
              @click="setTimeBy800(per, perKey)">
              {{ text }}
            </span>
            <v-icon v-if="hasIcon" x-small color="darkColor">mdi-account mdi-8px</v-icon>
          </div>
          <!-- <v-icon v-if="secondText" small color="darkColor">mdi-minus mdi-rotate-90</v-icon> -->
          <div class="right-contentItems">
            <span v-if="secondText" class="second-text">
              {{ secondText }}
            </span>
            <v-icon v-if="secondText && hasIcon" x-small color="darkColor">
              mdi-vector-square mdi-8px
            </v-icon>
          </div>
        </div>
      </div>
      <div class="bg-color-custom">
        <div class="triangle-topleft"></div>
      </div>
    </v-card>
  </div>
</template>

<script>
import CallMixin from "../Mixins/Call/CallMixin";

export default {
  mixins: [CallMixin],
  mounted() {
    this.setClasses();
  },
  props: {
    title: {
      type: String,
      require: true,
    },
    text: {
      type: String,
      require: true,
    },
    icon: {
      type: String,
      require: true,
    },
    size: {
      type: Number,
      require: true,
      default: 4,
    },
    per: {
      type: Boolean,
      require: false,
      default: false,
    },
    secondText: {
      type: String,
      require: false,
      default: "",
    },
    perKey: {
      type: String,
      require: false,
      default: "",
    },
    hasIcon: {
      type: Boolean,
      require: false,
      default: false,
    },
    clickable: {
      type: Boolean,
      require: false,
      default: true,
    },
  },
  data() {
    return {
      titleClass: "text-center items-title",
      textClass: "items-text",
    };
  },
  methods: {
    setClasses() {
      const sizeMap = {
        3: {
          titleClass: "title-time",
          textClass: "text-time"
        },
        4: {
          titleClass: "title-default",
          textClass: "text-default"
        },
        8: {
          titleClass: "title-default",
          textClass: "text-default"
        },
        12: {
          titleClass: "title-default",
          textClass: "text-default"
        }
      };

      const classes = sizeMap[this.size] || sizeMap[4];
      this.titleClass = `text-center ${classes.titleClass}`;
      this.textClass = classes.textClass;
    },
    setTimeBy800(per, perKey) {
      if (this.clickable == false) {
        return;
      }
      if (per == true) {
        if (this.$root.$refs.Edit800Mission) {
          this.$root.$refs.Edit800Mission.showSetTimeModal(perKey);
        } else if (this.$root.$refs.FollowUpDashboardDetail) {
          this.$root.$refs.FollowUpDashboardDetail.showSetTimeModal(perKey);
        }
      }
    },
    isPhoneNumber(number) {
      const iranPhoneRegex = /^(\+98|0)?9\d{9}$/;
      return iranPhoneRegex.test(number);
    },
    phoneText(phoneNumber) {
      const withCountryCode = phoneNumber?.replace("0", "+98");
      return withCountryCode;
    },
    callToCode(to) {
      const body = { to };
      this.callToCodeFunction(body);
    },
  },
};
</script>

<style scoped>
.main-card-detail {
  position: relative;
  border-radius: 14px !important;
}

.card-content-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
}

.right-content-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  gap: 8px;
  margin-right: auto;
  margin-left: 12px;
  flex: 1;
}

.right-content-wrapper .right-contentItems {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-right: auto;
  flex: 1;
}

.title-text {
  color: #212121;
  font-size: 14px;
  font-weight: 500;
  min-width: fit-content;
}

.title-time {
  color: #212121;
  font-size: 12px !important;
  font-weight: 500;
}

.title-default {
  color: #212121;
  font-size: 14px !important;
  font-weight: 500;
}

.text-content {
  color: #272727;
  font-size: 14px;
  font-weight: 600;
  /* cursor: pointer; */
}

.text-time {
  color: #272727;
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
}

.text-default {
  color: #272727;
  font-size: 13.5px;
  font-weight: 500;
}

.phone-button {
  margin-top: -4px;
  letter-spacing: normal;
}

.second-text {
  color: var(--v-darkColor-base);
  font-size: 14px;
  font-weight: 600;
}

.bg-color-custom {
  position: absolute;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: var(--v-oneFieldcolor-lighten4);
  border-right: 1px solid var(--v-darkColor-base);
  border-left: 1px solid var(--v-darkColor-base);
  border-radius: 13px;
}

.triangle-topleft {
  width: 65%;
  height: 64px;
  border-top: 68px solid #ffffff;
  border-right: 68px solid transparent;
  border-radius: 13px 0 0 13px;
}

.text-center {
  text-align: center;
}

.card-content-wrapper,
.card-content-wrapper * {
  z-index: 100;
}
</style>